import { useTranslation } from "react-i18next";

export default function PlaceHolder({
  title,
  description,
  img,
}: {
  title?: string;
  description?: string;
  img?: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      data-cy="placeholderMessage"
      className="my-auto text-center pb-2 md:pb-0 flex gap-6 flex-col justify-center items-center w-full px-4"
    >
      {!!img && (
        <div className="mx-auto">
          <img
            src={img}
            alt="place holder unscheduled reader"
            className="mx-auto"
          />
        </div>
      )}
      <div className="w-full">
        {!!title && (
          <h4 className="text-gray-700 text-lg leading-6 font-medium">
            {t(`placeholeder.${title}`)}
          </h4>
        )}
        {!!description && (
          <p className="mt-1 text-gray-500 text-sm leading-6">
            {t(`placeholeder.${description}`)}
          </p>
        )}
      </div>
    </div>
  );
}
